<div style="padding:-24px !important;">
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Select Markers</span>
            <button mat-icon-button class="mat-icon-button white-fg"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div class="content-card mat-white-bg wizard-content p-12" fxLayout="column">
        <div class="search-input-wrapper ml-8 m-sm-0 pb-8" fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="start center" style="max-width:400px;">
            <label for="search" class="mr-8">
                <mat-icon class="secondary-text">search</mat-icon>
            </label>
            <mat-form-field floatPlaceholder="never" fxFlex="1 0 auto">
                <input id="search" #search matInput placeholder="Search" [setFocus]="true">
            </mat-form-field>
        </div>

        <div class="w-100-p" style="flex: 1 1 auto; box-sizing: border-box; max-width: 470px; height: 100px;">

            <data-grid style="max-height: 100%;"
                #list
                [rows]="rows"
                [columns]="columns"
                [allowCustomisation]="false"
                [keyProperty]="'id'"
                [showButtons]="false"
                [showPager]="false"
                [showRowCount]="false"
                [showSearch]="false"
                [showSelection]="true"
                (onSelectionChanged)="selectionChanged($event)">
            </data-grid>
        </div>
    </div>
</div>
<div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <button id="btnSubmit" mat-raised-button
              type="submit"
              [disabled] = "(!hasLoaded) || (!selectionHasChanged)"
              (click)="save()"
              class="save-button mat-accent"
              aria-label="SAVE">
        SAVE
      </button>
    </div>
  </div>
